import React from 'react';
import { Link } from 'react-router-dom';
import '../css/newsQuoteBanner.css';
import shipsImage from '../img/bg-about-section3.jpg';

const NewsQuoteBanner = () => {
  return (
    <div
      className="news-quote-banner"
      style={{ backgroundImage: `url(${shipsImage})` }}
    >
      <div className="container">
        <div className="quote-banner-wrapper">
          <div className="quote-content">
            <h2 className="quote-title">Nhận báo giá vận chuyển ngay hôm nay!</h2>
            <Link to="/contact" className="quote-btn">
              Mẫu báo giá
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsQuoteBanner;